import React, { Component } from "react";
import Select from "react-select";
import { isMobile } from "react-device-detect";

const customStyles = {
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    width: "100%",
    borderWidth: "1px",
    borderRadius: "5px",
    margin: "2px"
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

import { connect } from "react-redux";

class GridFilters extends Component {
  getOptions = (data, fieldName, key) => {
    let newArray = [];
    if (!data && data === undefined) {
      //console.log("Data is undefined for SelectDropdown");
      return [];
    }

    //console.log("No of drop down records: " + data.length);
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      //console.log(JSON.stringify(this.props.filter));

      newArray.push({
        value: item[fieldName],
        label: item[fieldName],
        key: key
      });
    }
    return newArray;
  };

  getValue = fieldName => {
    // console.log(
    //   "Setting this value: " +
    //     JSON.stringify({
    //       value: this.props.value[fieldName],
    //       label: this.props.value[fieldName]
    //     })
    // );
    return {
      value: this.props.value[fieldName],
      label: this.props.value[fieldName]
    };
  };

  handleChange = (newValue, actionMeta, key) => {
    let newFilterVal = { ...this.props.value };
    if (actionMeta && actionMeta.action === "clear") {
      delete newFilterVal[key];
      this.props.stateHandler(newFilterVal, "searchFilters", false);
    } else {
      if (newValue && newValue !== undefined) {
        newFilterVal[key] = newValue.value;
        this.props.stateHandler(newFilterVal, "searchFilters", false);
      }
    }
  };

  getFiterFields = () => {
    //console.log(JSON.stringify(this.props.ogTableDef[this.props.path]));
    let fieldList = this.props.ogTableDef[this.props.path];
    if (fieldList && fieldList !== undefined) {
      return Object.keys(fieldList).map(key => {
        let fieldDefs = fieldList[key];

        if (
          fieldDefs &&
          fieldDefs.selectorSource &&
          fieldDefs.selectorSource.type === "static" &&
          fieldDefs.caption !== "SALUTATION" &&
          this.props.filtersList.includes(key)
        ) {
          let sourceData = fieldDefs.selectorSource.staticSource;
          //console.log(JSON.stringify(sourceData));
          let fieldName = fieldDefs.selectorSource.tableField;

          return (
            <Select
              isClearable
              onChange={(newVal, metaData) =>
                this.handleChange(newVal, metaData, key)
              }
              options={this.getOptions(sourceData, fieldName, key)}
              label={fieldDefs.caption}
              placeholder={"SELECT " + fieldDefs.caption}
              value={this.getValue(key)}
              styles={customStyles}
              defaultValue={"SELECT " + fieldDefs.caption}
              fullwidth
              theme={theme => ({
                ...theme,
                borderRadius: 5,
                colors: {
                  ...theme.colors,
                  primary: "blue"
                },
                borderWidth: "1px",
                borderColor: "blue"
              })}
            />
          );
        } else if (
          fieldDefs &&
          fieldDefs.selectorSource &&
          fieldDefs.selectorSource.type === "table" &&
          fieldDefs.caption !== "SALUTATION" &&
          this.props.filtersList.includes(key)
        ) {
          let sourceData = fieldDefs.selectorSource.table;
          //console.log(JSON.stringify(sourceData));
          let fieldName = fieldDefs.selectorSource.tableField;

          return (
            <Select
              isClearable
              onChange={(newVal, metaData) =>
                this.handleChange(newVal, metaData, key)
              }
              options={this.getOptions(this.props[sourceData], fieldName, key)}
              label={fieldDefs.caption}
              placeholder={"SELECT " + fieldDefs.caption}
              value={this.getValue(key)}
              styles={customStyles}
              defaultValue={"SELECT " + fieldDefs.caption}
              fullwidth
              theme={theme => ({
                ...theme,
                borderRadius: 5,
                colors: {
                  ...theme.colors,
                  primary: "blue"
                },
                borderWidth: "1px",
                borderColor: "blue"
              })}
            />
          );
        }
      });
    }
  };

  getMobileStyle = () => {
    if (isMobile) {
      return {
        display: "block"
      };
    }
  };

  render() {
    return <div>{this.getFiterFields()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    users: state.db.users,
    projects: state.db.projects,
    attendance: state.db.attendance,
    contacts: state.db.contacts,
    logistics: state.db.logistics,
    notices: state.db.notices,
    projectInvoices: state.db.projectInvoices,
    projectClaims: state.db.projectClaims,
    projectDos: state.db.projectDos,
    projectPos: state.db.projectPos,
    projectQuotes: state.db.projectQuotes,
    reports: state.db.reports,
    suppliers: state.db.suppliers,
    tasks: state.db.tasks,
    currentUser: state.db.userProfile
  };
}

export default connect(
  mapStateToProps,
  null
)(GridFilters);



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/GridFilters.jsx